import React from "react";
import { getClassName } from "@sscs/utils";
import { toast, } from "react-toastify/unstyled";
import CloseButton from "./CloseButton";
import styles from "./toast.module.scss";
import ToastCard from "./ToastCard";
const baseOptions = {
    icon: false,
    closeButton: CloseButton,
    hideProgressBar: true,
    pauseOnFocusLoss: false,
};
const variantClassName = {
    error: styles["toast-error"],
    warning: styles["toast-warning"],
    success: styles["toast-success"],
    info: styles["toast-info"],
};
const presetOptions = (type) => {
    const className = getClassName(styles.toast, variantClassName[type]);
    switch (type) {
        case "error":
            return {
                ...baseOptions,
                className,
                autoClose: 5000,
                pauseOnFocusLoss: true,
                hideProgressBar: true,
            };
        case "success":
            return {
                ...baseOptions,
                className,
                hideProgressBar: false,
                progressClassName: styles["progress-success"],
            };
        default:
            return { ...baseOptions, className };
    }
};
const buildCard = (data) => {
    var _a;
    return (React.createElement(ToastCard, { title: data.title, description: data.description, actions: data.actions, type: (_a = data.type) !== null && _a !== void 0 ? _a : "default" }));
};
const resolveOptions = (data) => {
    var _a;
    const options = presetOptions((_a = data.type) !== null && _a !== void 0 ? _a : "default");
    if (data.actions && data.actions.length > 0)
        options.closeOnClick = false;
    return { ...options, ...data.props };
};
/** Fire a toast rendered in the toast card. */
const showToast = (data) => toast(buildCard(data), resolveOptions(data));
/** Rebuild the card and preset options for an existing toast. */
export const updateToast = (id, data) => {
    toast.update(id, {
        render: buildCard(data),
        ...resolveOptions(data),
    });
};
export default showToast;
//# sourceMappingURL=Toast.js.map